export const RestaurantWizardSteps = {
  BASIC: 'basic',
  LOCATION: 'location',
  HOURS: 'hours',
  LOGO: 'logo',
  PHOTOS: 'photos',
  LAYOUT: 'layout',
  SOCIAL: 'social',
  CONFIRM: 'confirm'
} as const;

export type RestaurantWizardStep = typeof RestaurantWizardSteps[keyof typeof RestaurantWizardSteps];

export const RESTAURANT_WIZARD_STEP_ORDER: RestaurantWizardStep[] = [
  RestaurantWizardSteps.BASIC,
  RestaurantWizardSteps.LOCATION,
  RestaurantWizardSteps.HOURS,
  RestaurantWizardSteps.LOGO,
  RestaurantWizardSteps.PHOTOS,
  RestaurantWizardSteps.LAYOUT,
  RestaurantWizardSteps.SOCIAL,
  RestaurantWizardSteps.CONFIRM
];

export const RESTAURANT_WIZARD_STEP_TITLES: Record<RestaurantWizardStep, string> = {
  [RestaurantWizardSteps.BASIC]: 'BASIC INFORMATION',
  [RestaurantWizardSteps.LOCATION]: 'LOCATION',
  [RestaurantWizardSteps.HOURS]: 'HOURS',
  [RestaurantWizardSteps.LOGO]: 'LOGO',
  [RestaurantWizardSteps.PHOTOS]: 'PHOTOS',
  [RestaurantWizardSteps.LAYOUT]: 'MENU LAYOUT',
  [RestaurantWizardSteps.SOCIAL]: 'SOCIAL MEDIA',
  [RestaurantWizardSteps.CONFIRM]: 'REVIEW & CONFIRM'
};

export const isRestaurantWizardStep = (step: string | undefined): step is RestaurantWizardStep =>
  !!step && RESTAURANT_WIZARD_STEP_ORDER.includes(step as RestaurantWizardStep);

export const RESTAURANT_PROFILE_SIDEBAR_STEPS: RestaurantWizardStep[] = RESTAURANT_WIZARD_STEP_ORDER.filter(
  (step) => step !== RestaurantWizardSteps.CONFIRM
);
